import { memo } from "react";
import { Grid2, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import WesentlichkeitsCard from "./WesentlichkeitsCard";
import WesentlichkeitsSettings from "./WesentlichkeitsSettings";
import WesentlichkeitsIROCard from "./WesentlichkeitsIROCard";

const WesentlichkeitAccordion = memo(() => {
    const { pathname } = useLocation();

    return (
        <Grid2 container size={12} spacing={6}>
            {pathname.endsWith("einstellungen") && <WesentlichkeitsSettings />}

            {pathname.includes("analyse/esrs-e1") && (
                <Grid2 container size={12}>
                    <Grid2 size={12}>
                        <Typography variant={"h4"}>Wesentlichkeitsanalyse</Typography>
                    </Grid2>

                    <Grid2 container size={12} spacing={3}>
                        <Grid2 size={12}>
                            <WesentlichkeitsCard title={"Climate Change"} />
                        </Grid2>
                    </Grid2>
                </Grid2>
            )}

            {pathname.includes("analyse/esrs-e2") && (
                <Grid2 container size={12}>
                    <Grid2 size={12}>
                        <Typography variant={"h4"}>Wesentlichkeitsanalyse</Typography>
                    </Grid2>

                    <Grid2 container size={12} spacing={3}>
                        <Grid2 size={12}>
                            <WesentlichkeitsCard title={"Umweltverschmutzung"} />
                        </Grid2>
                    </Grid2>
                </Grid2>
            )}

            {pathname.includes("analyse/esrs-e3") && (
                <Grid2 container size={12}>
                    <Grid2 size={12}>
                        <Typography variant={"h4"}>Wesentlichkeitsanalyse</Typography>
                    </Grid2>

                    <Grid2 container size={12} spacing={3}>
                        <Grid2 size={12}>
                            <WesentlichkeitsCard title={"Wasser- und Meeresressoucen"} />
                        </Grid2>
                    </Grid2>
                </Grid2>
            )}

            {pathname.includes("analyse/esrs-e4") && (
                <Grid2 container size={12}>
                    <Grid2 size={12}>
                        <Typography variant={"h4"}>Wesentlichkeitsanalyse</Typography>
                    </Grid2>

                    <Grid2 container size={12} spacing={3}>
                        <Grid2 size={12}>
                            <WesentlichkeitsCard title={"Biodiversität & Ökosysteme"} />
                        </Grid2>
                    </Grid2>
                </Grid2>
            )}

            {pathname.endsWith("iro") && (
                <Grid2 container size={12}>
                    <Grid2 size={12}>
                        <Typography variant={"h4"}>IRO-Analyse</Typography>
                    </Grid2>

                    <Grid2 size={12}>
                        <WesentlichkeitsIROCard title={"Wasser und Meeresressoucen"} />
                    </Grid2>
                </Grid2>
            )}
        </Grid2>
    );
});

export default WesentlichkeitAccordion;
